<template>
  <div class="absolute inset-0 overflow-hidden">
    <div
      class="absolute inset-0"
      :class="backgroundClass || 'bg-gradient-to-br from-neutral-300 to-neutral-500'"
    />
    <div
      v-if="backgroundClass"
      class="absolute inset-0 bg-gradient-to-br from-white/45 to-white/15"
    />

    <img
      v-if="src"
      :src="src"
      alt=""
      class="absolute -inset-6 h-[calc(100%+3rem)] w-[calc(100%+3rem)] scale-110 object-cover blur-2xl"
    >

    <div class="absolute inset-0 bg-black/5" />

    <div
      v-if="src && showFeature"
      class="image-banner-media__feature absolute inset-0 xl:inset-y-0 xl:left-[58%] xl:right-auto xl:w-[75%] xl:-translate-x-1/2 2xl:w-[55%] 3xl:w-[42%]"
    >
      <img
        :src="src"
        :alt="alt"
        :width="width"
        :height="height"
        class="h-full w-full object-cover object-center drop-shadow-2xl"
      >
    </div>

    <div class="image-banner-media__vignette absolute inset-0" />
    <slot name="overlay" />
  </div>
</template>

<script setup>
  defineProps({
    src: String,
    width: Number,
    height: Number,
    showFeature: {
      type: Boolean,
      default: true
    },
    backgroundClass: String,
    alt: {
      type: String,
      default: ''
    }
  });
</script>

<style scoped>
  .image-banner-media__feature {
    -webkit-mask-image: none;
    mask-image: none;
  }

  .image-banner-media__vignette {
    background: radial-gradient(
      ellipse at 58% 50%,
      transparent 28%,
      rgba(10, 15, 9, 0.1) 72%,
      rgba(10, 15, 9, 0.2) 100%
    );
  }

  @media (min-width: 1400px) {
    .image-banner-media__feature {
      -webkit-mask-image: linear-gradient(90deg, transparent 0%, black 10%, black 90%, transparent 100%);
      mask-image: linear-gradient(90deg, transparent 0%, black 10%, black 90%, transparent 100%);
    }
  }
</style>
